<mat-toolbar>
  <mat-toolbar-row fxFlex fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
    <span class="title">{{ title }}</span>
    <span class="subtitle">{{ startDateFormatted }} | {{ numWeeks }} weeks</span>
    <span fxFlex></span>
    <mat-chip-list>
      <mat-chip *ngIf="!isOwner">Reviewer</mat-chip>
    </mat-chip-list>
    <button mat-icon-button (click)="refreshed.emit()" *ngIf="false">
      <mat-icon>refresh</mat-icon>
    </button>
    <button id="plan-level-menu" mat-icon-button [matMenuTriggerFor]="planMenu">
      <mat-icon>more_vert</mat-icon>
    </button>

    <mat-menu #planMenu id="plan-menu">
      <button mat-menu-item (click)="viewSwitched.emit()">
        <mat-icon>visibility</mat-icon>
        <span>Switch View</span>
      </button>
      <button mat-menu-item (click)="edited.emit()" *ngIf="isOwner">
        <mat-icon>create</mat-icon>
        <span>Edit</span>
      </button>
      <button mat-menu-item (click)="published.emit()" *ngIf="isOwner" [disabled]="!isOnline">
        <mat-icon>share</mat-icon>
        <span>Publish</span>
      </button>
      <button mat-menu-item (click)="shared.emit()" *ngIf="isOwner" [disabled]="!isOnline">
        <mat-icon>send</mat-icon>
        <span>Share</span>
      </button>
      <button mat-menu-item (click)="copied.emit()" [disabled]="!isOnline">
        <mat-icon>filter_none</mat-icon>
        <span>Copy</span>
      </button>
      <!-- <button mat-menu-item (click)="monthPrinted.emit()">
        <mat-icon>print</mat-icon>
        <span>Print Month</span>
      </button>
      <button mat-menu-item (click)="weekPrinted.emit()">
        <mat-icon>print</mat-icon>
        <span>Print Week</span>
      </button> -->
    </mat-menu>
  </mat-toolbar-row>
</mat-toolbar>
